__turbopack_context__.v({
  "image": "SmallLogo-module-scss-module__WHvEvq__image",
});
